module.exports = __webpack_public_path__ + "img/check.a051e748.svg";